import React, { useState, useContext, useEffect } from "react";

import ComponentContainer from "./utils/ComponentContainer";
import Field from "./forms/Field";
import AuthContext from "./Context/AuthContext";
import Profile from './Profile'

const Connexion = ({history}) => {
  const { manageLoginForm, manageSignUpForm, userProfile, isLoggedIn } = useContext(AuthContext);
  const [togglePanel, setTogglePanel] = useState(true);
  const [loginForm, setLoginForm] = useState({
    email: "admin@admin.com",
    password: "admin",
  });
  const [signUpForm, setSignUpForm] = useState({
    email: "admin@admin.com",
    password: "admin",
    vpassword: "admin",
  });

  const resetFields = (form, setFormMethod) => {
    Object.keys(form).forEach(key => {
        setFormMethod(state => {
            return { ...state, [key]: "" }
        })
    })
  };

  /**
   * Login Form Methods
   * Managed by AuthContext - manageLoginForm
   */

  // TODO: handle login fields validation
  const handleLoginForm = (field) => {
    setLoginForm({
      ...loginForm,
      [field.name]: field.value,
    });
  };

  const sendLoginForm = (e) => {
    e.preventDefault();
    manageLoginForm(loginForm);
    resetFields(loginForm, setLoginForm);
  };

  /**
   * Sign Up Form Methods
   * Managed by AuthContext - manageSignUpForm
   */

  // TODO: handle signup fields validation
  const handleSignupForm = (field) => {
    setSignUpForm({
      ...signUpForm,
      [field.name]: field.value,
    });
  };

  const sendSignUpForm = (e) => {
    e.preventDefault();
    manageSignUpForm(signUpForm);
    resetFields(signUpForm, setSignUpForm);
  };

  if(isLoggedIn()) {
    return (
      <Profile />
    )
  }
  else {
    return (
      <ComponentContainer>
        <div className="connect">
          <h1>Login / Sign up</h1>
          <div className="connect__cards">
            <div
              onClick={() => (togglePanel ? "" : setTogglePanel(!togglePanel))}
              className={`connect__card login ${togglePanel ? "active" : ""}`}
            >
              <h5>Login</h5>
              <form onSubmit={sendLoginForm}>
                <Field name="email" type="email" value={loginForm.email} handleForm={handleLoginForm} />
                <Field name="password" type="password" value={loginForm.password} handleForm={handleLoginForm} />
                <button onClick={sendLoginForm}>Login</button>
              </form>
            </div>
            <div
              onClick={() => (togglePanel ? setTogglePanel(!togglePanel) : "")}
              className={`connect__card signul ${togglePanel ? "" : "active"}`}
            >
              <h5>Sign up</h5>
              <form onSubmit={sendSignUpForm}>
                <Field name="email" type="email" value={signUpForm.email} handleForm={handleSignupForm} />
                <Field name="password" type="password" value={signUpForm.password} handleForm={handleSignupForm} />
                <Field
                  title="Confirm password"
                  name="vpassword"
                  type="password"
                  value={signUpForm.vpassword}
                  placeholder="Password verification"
                  handleForm={handleSignupForm}
                />
                <button onClick={sendSignUpForm}>Sign up</button>
              </form>
            </div>
          </div>
          <div className="connect__toggle" onClick={() => setTogglePanel(!togglePanel)}>
            {togglePanel ? "I want to create an account" : "I have already an account"}
          </div>
        </div>
      </ComponentContainer>
    );
  }

};

export default Connexion;
